import React, { useContext, useEffect, useRef, useState } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";
import StudyClippingButton from "../Tools/StudyClippingButton";
import userContext from "../../../../context/users/UserContext";
import themeContext from "../../../../context/theme/ThemeContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import "./StudyMaskingProfile.css";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import { savingBoundingBoxJsonData } from "../../helpers/BoundingBoxUtilities";
import { getViewport, resetViewport, resizeViewport } from "../../helpers/CornerstoneViewportService";
import { applyMaskingProfileData, deleteMaskingProfile, saveMaskingProfileData, setDefaultMaskingProfile } from "../../../../service/StudyViewerService";
import { TOAST_TYPE } from "../../../../constants/Constants";
import toastContext from "../../../../context/toast/ToastContext";
import { Enums, annotation } from "@cornerstonejs/tools";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import ModalMain from "../../../../components/Modal/ModalMain";
import { t } from "i18next";

const StudyMaskingProfile = ({ viewportIndex, viewportData, currentImage, loaderRunning, setLoaderRunning }) => {

  const ref = useRef();
  const { getAlterColor, getThemeColor } = useContext(themeContext);
  const { maskedBoundingBox, setMaskedBoundingBox } = useContext(studyviewerContext);
  const { setConfirmAlertModal, confirmAlertModal } = useContext(studyReportContext);
  const { handleAddMaskingProfile, setBoundingBoxMode, maskingProfileData, setMaskingProfileData, 
    isCreatingMaskingProfile, setIsCreatingMaskingProfile, removeOldMaskedAnnotations, addMaskedBoundingBoxesToViewport, 
    isMaskingEnabled, setIsMaskingEnabled, handleDefaultToolChange } = useContext(ViewportContext)
  const { showToastv2 } = useContext(toastContext);
  const [showProfileList, setShowProfileList] = useState(false);
  const [imageId, setImageId] = useState(null);
  const [uniqueProfiles, setUniqueProfiles] = useState([]);
  const [confirmAction, setConfirmAction] = useState(null);
  
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowProfileList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(()=> {
      console.log("Current Image", currentImage, viewportData);
      if(viewportData == undefined)
        return;
      let imageId = viewportData.stack.images[currentImage]?.id;
      console.log("image id", imageId);
      setImageId(imageId);
  }, [currentImage, viewportData]);

  const toggleOverlay = () => {
    if (!isCreatingMaskingProfile) {
      setShowProfileList((prev) => !prev);
    }
  };

  const toggleMaskingOverlay = () => {
    setIsMaskingEnabled((prev) => !prev);
  };

  useEffect(()=>{
    if(isMaskingEnabled){
      addMaskedBoundingBoxesToViewport();
    }
    else{
      removeOldMaskedAnnotations();
    }
  }, [isMaskingEnabled])

  const startCreatingProfile = () => {
    setIsCreatingMaskingProfile(true);
    setShowProfileList(false);
    removeOldMaskedAnnotations();

    handleAddMaskingProfile();
  };

  const saveNewProfile = async () => {
    console.log("newly saved profile," , maskingProfileData);

    if (!hasAnnotations(maskingProfileData)) {
      showToastv2(TOAST_TYPE.INFO, "Masking Profile not Selected!");
      return;
    }

    setBoundingBoxMode(false);
    handleDefaultToolChange();
    setLoaderRunning(true);

    try {
        let data = await reformateBoundingBox(
            maskingProfileData,
            viewportIndex
        );
        let studyIdString = viewportData.study;
        let studyIdInteger = parseInt(studyIdString, 10);

        const body = {
            studyId: studyIdInteger,
            allBoundingBox: data.measurementData,
        };

      let response = await saveMaskingProfileData(body);
      console.log(response);
      if(response.status == 200 && response.data.result == "SUCCESS" && response.data.data != undefined){
        setMaskedBoundingBox(response.data.data.imageMaskingProfiles);
        showToastv2(TOAST_TYPE.SUCCESS, "Masking Profile Saved Successfully!");
      } else{
        showToastv2(TOAST_TYPE.ERROR, "Some Error Ocurred.");
      }
      setIsCreatingMaskingProfile(false);
      setMaskingProfileData([]);
      setLoaderRunning(false);
    } catch (error) {
      console.error("Failed to save profile", error);
      setLoaderRunning(false);
    }
  };

  const hasAnnotations = (data) =>
    data && Object.values(data).some(profiles =>
      Object.values(profiles).some(annotations => annotations.length > 0)
  );

  const reformateBoundingBox = async (
      maskingProfileData,
      activeViewportIndex
    ) => {
      const activeViewport = await getViewport(activeViewportIndex);
  
      if (activeViewport != null || activeViewport != undefined) {
        let data = {};
        let allAnnotationUID = new Set();
        for (const key in maskingProfileData) {
          if (!data[key]) {
            data[key] = {};
          }
  
          for (const key2 in maskingProfileData[key]) {
            if (maskingProfileData[key] != undefined) {
              maskingProfileData[key][key2]?.map((ele, ind) => {
                allAnnotationUID.add(ele.annotation.annotationUID);
              });
              let temp = [];
              temp = maskingProfileData[key][key2]?.map((ele, ind) => {
                const { imageData, dimensions } = activeViewport?.getImageData();
  
                let updatedPoints = [];
                updatedPoints.push(
                  imageData.worldToIndex(ele.annotation.data.handles.points[0])
                );
                updatedPoints.push(
                  imageData.worldToIndex(ele.annotation.data.handles.points[1])
                );
                updatedPoints.push(
                  imageData.worldToIndex(ele.annotation.data.handles.points[2])
                );
                updatedPoints.push(
                  imageData.worldToIndex(ele.annotation.data.handles.points[3])
                );
  
                let updatedJson = savingBoundingBoxJsonData(
                  updatedPoints,
                  ele.annotation.annotationUID
                );
                return JSON.stringify(updatedJson);
              });
              if (temp.length == 0) {
                continue;
              } else {
                data[key][key2] = temp;
              }
            }
          }
        }
  
        data["AnnotationUIDs"] = allAnnotationUID;
        console.log("--------- Final data ------------");
        console.log(data);
        return { loadedComplete: true, measurementData: data };
      }
    };

    

  useEffect(() => {
    if (!maskedBoundingBox) return;

    const profileMap = new Map();

    maskedBoundingBox.forEach((img) => {
      const imgId = img.imageId;

      img.annotationMeasurements.forEach((measurement) => {
        const { profileId, profileName } = measurement;

        if (!profileMap.has(profileName)) {
          profileMap.set(profileName, {
            profileId,
            profileName,
            imageIds: new Set()
          });
        }
        profileMap.get(profileName).imageIds.add(imgId);
      });
    });

    // Convert Map to Array and convert Set to Array
    const deduplicatedProfiles = Array.from(profileMap.values()).map((profile) => ({
      ...profile,
      imageIds: Array.from(profile.imageIds)
    }));

    setUniqueProfiles(deduplicatedProfiles);
  }, [maskedBoundingBox]);

  useEffect(()=>{
    console.log("Unique Profiles:", uniqueProfiles);
  },[uniqueProfiles]);

  const applyMaskingProfileToImage = async (profile) => {
    
    console.log("apply masking profile to the image", profile, imageId, maskedBoundingBox);
    
    if (!imageId) return;

    let studyIdString = viewportData.study;
    let studyIdInteger = parseInt(studyIdString, 10);

    if(profile.imageIds.includes(imageId)){
      console.log("profile already saved");
      return;
    }

    const body = {
      studyId: studyIdInteger,
      imageId: imageId,
      profileName: profile.profileName
    };

    let response = await applyMaskingProfileData(body);
    console.log(response);
      if(response.status == 200 && response.data.result == "SUCCESS" && response.data.data != undefined){
        setMaskedBoundingBox(response.data.data.imageMaskingProfiles);
        showToastv2(TOAST_TYPE.SUCCESS, "Masking Profile Saved Successfully!");
      } else{
        showToastv2(TOAST_TYPE.ERROR, "Some Error Ocurred.");
      }
  }

  const isProfileVisuallyActive = (profile) => {
    const isExplicitlyApplied = profile.imageIds?.includes(imageId);
    const isDefaultProfile = profile.profileName === "DEFAULT";
    
    // Check if this imageId is present in any non-DEFAULT profile
    const isImageUsedInOtherProfile = maskedBoundingBox?.some(img => 
      img.imageId === imageId &&
      img.annotationMeasurements?.some(m => m.profileName !== "DEFAULT")
    );

    return (
      isExplicitlyApplied ||
      (isDefaultProfile && !isImageUsedInOtherProfile)
    );
  };

  const handleSetDefault = (profile) => {
    setConfirmAction({
      type: "SET_DEFAULT",
      profile,
      message: `Do you want to set "${profile.profileId}" as the default profile? \n Once marked as default, this profile will be set as the default for all studies of the same modality within this firm.`,
    });
  };

  const handleDeleteProfile = (profile) => {
    setConfirmAction({
      type: "DELETE",
      profile,
      message: `Are you sure you want to delete "${profile.profileId}" profile? \n Once deleted, all images where this masking profile has been applied will also be removed.`,
    });
  };

  const proceedWithConfirmedAction = async () => {
    const { type, profile } = confirmAction;
    let studyIdString = viewportData.study;
    let studyIdInteger = parseInt(studyIdString, 10);

    const body = {
        studyId: studyIdInteger,
        profileName: profile.profileName
    };

    setLoaderRunning(true);

    if (type === "SET_DEFAULT") {
      console.log("Set default for", profile);

      let response = await setDefaultMaskingProfile(body);
      console.log(response);
        if(response.status == 200 && response.data.result == "SUCCESS" && response.data.data != undefined){
          setMaskedBoundingBox(response.data.data.imageMaskingProfiles);
          showToastv2(TOAST_TYPE.SUCCESS, "Masking Profile Set Default Successfully!");
        } else{
          showToastv2(TOAST_TYPE.ERROR, "Some Error Ocurred.");
        }
    } else if (type === "DELETE") {
      console.log("Delete profile", profile);

      let response = await deleteMaskingProfile(body);
      console.log(response);
        if(response.status == 200 && response.data.result == "SUCCESS" && response.data.data != undefined){
          setMaskedBoundingBox(response.data.data.imageMaskingProfiles);
          showToastv2(TOAST_TYPE.SUCCESS, "Masking Profile Deleted Successfully!");
        } else{
          showToastv2(TOAST_TYPE.ERROR, "Some Error Ocurred.");
        }
    }
    setLoaderRunning(false);
    setConfirmAction(null);
  };

  const cancelConfirmAction = () => {
    setConfirmAction(null);
  };

  let DefaultButtonList = [
    {
      title: t("button.no"),
      onclick: () => { cancelConfirmAction() },
    },
  ];

  let PrimaryButtonList = [
    {
      title: t("button.yes"),
      onclick: () => { proceedWithConfirmedAction() }
    }
  ]

  const modalDetails = confirmAction ? {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={"Alert"}
        handleCancel={cancelConfirmAction}
      />
    ),
    body: (
      <div className="global-modal-body" style={{ color: getThemeColor("primary-color") }}>
        {confirmAction.message}
      </div>
    ),
    footer: <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList} />,
    width: "500px",
  } : null;



  return (
    <div className="viewport-overlay-study-masking-profile" ref={ref}>
      <div style={{display: "flex", flexDirection: "column"}}>
        <span>
            <span title= {isMaskingEnabled ? "Turn Off Masking" : "Turn On Masking"} 
            style={{ opacity: isCreatingMaskingProfile || maskedBoundingBox.length == 0 ? 0.4 : 1, pointerEvents: isCreatingMaskingProfile || maskedBoundingBox.length == 0 ? "none" : "auto" }}
            onClick={() => toggleMaskingOverlay()} 
            className={`${isMaskingEnabled ? 'masking-toggle-on-button' : 'masking-toggle-off-button'} ${loaderRunning ? 'disabled' : ''}`}></span>
        </span>
    
        <span>
            <span title= {"Masking Profile"} 
            style={{ opacity: isCreatingMaskingProfile ? 0.4 : 1, pointerEvents: isCreatingMaskingProfile ? "none" : "auto" }}
            onClick={() => toggleOverlay()} 
            className={`masking-image-button ${loaderRunning ? 'disabled' : ''}`}></span>
        </span>

        {isCreatingMaskingProfile && (
          <span>
            <span title="Save new profile"
            onClick={saveNewProfile} 
            className={`masking-save-button ${loaderRunning ? 'disabled' : ''}`}></span>
          </span>
        )}
      </div>

      {showProfileList && (
        <div className="masking-profile-overlay">
          <p className="overlay-header" style={{ color: getAlterColor("#A19F9D", "#000") }}>
            Masking Profiles
          </p>
          <ul className="profile-list">
            <li className="profile-item create-button" onClick={startCreatingProfile}>
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", paddingLeft: "5px"}}>
              ➕ Create New Profile</div>
            </li>
            {uniqueProfiles?.map((profile) => (
              <li
                key={profile.profileName}
                className={`profile-item ${isProfileVisuallyActive(profile) ? "selected" : ""}`}
              >
                <div onClick={() => {applyMaskingProfileToImage(profile);}} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between",  width: "100%" }}>
                  <div style={{display: "flex", alignItems: "center",justifyContent: "space-between", paddingLeft: "5px"}}>
                    <span>{profile.profileId}</span>
                    {isProfileVisuallyActive(profile) && 
                      <span className="tick-icon" style={{ color: "#0078d4" }}>✔</span>
                    }
                  </div>
                  <div className="profile-actions" style={{ display: "flex", justifyContent: "flex-end", gap: "8px", margin: "3px" }}>
                    {profile.profileName !== "DEFAULT" && (<>
                      <span
                        className="profile-default-btn"
                        onClick={(e) => {
                          e.stopPropagation(); 
                          handleSetDefault(profile)}}
                        title="Mark as Default"
                      >
                      </span>
                      </>
                    )}
                    <span
                      className="profile-delete-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteProfile(profile)
                      }}
                      title="Delete Profile"
                    >
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
      {confirmAction && modalDetails &&
            <ModalMain
              updatedModal={true}
              modalDetails={modalDetails}
              showModal={true}
            />
      }
    </div>
  );
};

export default StudyMaskingProfile;
